import { handleActions } from 'redux-actions';

export const defaultAlert = { show: false, success: false, message: '', option: {} };

export default handleActions(
	{
		OPEN_ALERT: (state, action) => ({
			...state,

			[action.payload.type]: {
				...state[action.payload.type],
				show: true,
				option: action.payload.option,
				message: action.payload.message,
				success: action.payload.success,
			},
		}),

		CLOSE_ALERT: (state, action) => ({
			...state,

			[action.payload.type]: {
				...state[action.payload.type],
				show: false,
				message: '',
			},
		}),

		LOGOUT_FULFILLED: state => ({
			...state,

			generic: defaultAlert,
			settings: defaultAlert,
			loginSignup: defaultAlert,
			reserve: defaultAlert,
			reserveRecord: defaultAlert,
			booking: defaultAlert,
			overview: defaultAlert,
		}),
	},
	{
		generic: defaultAlert,
		settings: defaultAlert,
		loginSignup: defaultAlert,
		reserve: defaultAlert,
		reserveRecord: defaultAlert,
		booking: defaultAlert,
		overview: defaultAlert,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/alert.js